// extracted by mini-css-extract-plugin
export var mainContent = "MainTextBlock-module--mainContent--736d1";
export var white = "MainTextBlock-module--white--0fd64";